import React, { useState } from "react";
import { RotateCcw } from "lucide-react";
import AppButton from "./AppButton";
import ConfirmModal from "./ConfirmModal";

/**
 * ResetButton — a standard "Reset" action for full-page forms.
 *
 * Confirms via ConfirmModal (never the native browser dialog) before calling
 * `onReset`, which should restore the form to its pristine state. Designed to
 * sit between Cancel and the primary Add/Update button in a FormActionBar.
 *
 * Props:
 *   onReset      — invoked after the user confirms
 *   label        — button label (default "Reset")
 *   disabled     — disables the button
 *   title / message / confirmText — ConfirmModal copy overrides
 */
const ResetButton = ({
  onReset,
  label = "Reset",
  disabled = false,
  title = "Reset form?",
  message = "This discards the changes you've made and restores the form to how it was. This can't be undone.",
  confirmText = "Reset",
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <>
      <AppButton
        variant="outline"
        type="button"
        disabled={disabled}
        onClick={() => setShowConfirm(true)}
      >
        <RotateCcw size={16} /> {label}
      </AppButton>
      <ConfirmModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={() => {
          setShowConfirm(false);
          onReset && onReset();
        }}
        title={title}
        message={message}
        confirmText={confirmText}
        cancelText="Cancel"
        variant="warning"
      />
    </>
  );
};

export default ResetButton;
